import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardBody,
} from 'reactstrap';
import { formatCurrency } from 'utils/formatCurrency';
import {
  formatCollateralAmount,
  formatLiquidationDate,
} from '../../utils/cryptoUtils';
import './LiquidationDetailsCard.scss';

const LiquidationDetailsCard = ({
  liquidationDate,
  collateralLiquidated,
  assetType,
  liquidationProceeds,
  principalBalance,
}) => {
  const navigate = useNavigate();

  if (
    liquidationDate == null
    && collateralLiquidated == null
    && liquidationProceeds == null
  ) {
    return null;
  }

  const formattedDate = formatLiquidationDate(liquidationDate);
  const formattedCollateral = formatCollateralAmount(collateralLiquidated, assetType);
  const formattedProceeds = liquidationProceeds != null
    ? `$${formatCurrency(liquidationProceeds, 2)}`
    : '-';

  const handleViewDetails = (e) => {
    e.preventDefault();
    navigate('/consumer/loans', { state: { activeTab: 4 } });
  };

  return (
    <Card className="liquidation-details-card">
      <CardHeader className="text-left liquidation-details-card__header">
        <span className="liquidation-details-card__title">
          Liquidation Summary
        </span>
        <a
          href="#liquidation-details"
          className="liquidation-details-card__link"
          onClick={handleViewDetails}
        >
          View Liquidation Details
        </a>
      </CardHeader>
      <CardBody className="pt-2">
        <table className="liquidation-details-card__table">
          <tbody style={{ border: 'none' }}>
            <tr>
              <td className="liquidation-details-card__label">Liquidation Date</td>
              <td className="liquidation-details-card__value">{formattedDate}</td>
            </tr>
            <tr>
              <td className="liquidation-details-card__label">Collateral Liquidated</td>
              <td className="liquidation-details-card__value">{formattedCollateral}</td>
            </tr>
            <tr>
              <td className="liquidation-details-card__label">Liquidation Proceeds</td>
              <td className="liquidation-details-card__value">{formattedProceeds}</td>
            </tr>
          </tbody>
        </table>

        {principalBalance <= 0 && (
          <div className="liquidation-details-card__satisfied-alert" role="status">
            <svg
              className="liquidation-details-card__satisfied-icon"
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <circle cx="10" cy="10" r="10" fill="#2563eb" />
              <circle cx="10" cy="6" r="1.25" fill="#fff" />
              <path d="M10 8.75v6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
            <span>
              If you are eligible for any refund, it will be processed within 7 business days.
            </span>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

LiquidationDetailsCard.propTypes = {
  liquidationDate: PropTypes.string,
  collateralLiquidated: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  assetType: PropTypes.string,
  liquidationProceeds: PropTypes.number,
  principalBalance: PropTypes.number,
};

LiquidationDetailsCard.defaultProps = {
  liquidationDate: null,
  collateralLiquidated: null,
  assetType: null,
  liquidationProceeds: null,
  principalBalance: 0,
};

export default LiquidationDetailsCard;
